import React from "react";
import ReactModal from "react-modal";
import { Player, BigPlayButton } from "video-react";
import i18n from "../../i18n";

const Tutorial = ({ closeVideoModal }) => {
  return (
    <ReactModal
      isOpen={true}
      onRequestClose={closeVideoModal}
      contentLabel="Example Modal"
      className="videoPopup"
      shouldCloseOnEsc={false}
    >
      <div
        className="modal modal-lg-fullscreen fade show"
        id="startConversation"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-dialog-zoom">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{i18n.t("tutorialTitle")}</h5>
              <button
                type="button"
                className="close"
                onClick={() => closeVideoModal()}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body ">
              <div className="row">
                <Player
                  src="http://schoolbook.ge/static/media/online-chat-tutorial.mp4"
                  playsInline
                  fluid={false}
                  width={"100%"}
                  height={539}
                >
                  <BigPlayButton position="center" />
                </Player>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};
export default Tutorial;
